import { io, type Socket } from 'socket.io-client';
import { API_ORIGIN } from '../api/client';

let adminRealtimeSocket: Socket | null = null;

export const getAdminRealtimeSocket = (): Socket => {
  if (!adminRealtimeSocket) {
    adminRealtimeSocket = io(API_ORIGIN, {
      autoConnect: false,
      withCredentials: true,
      transports: ['websocket'],
    });
  }

  return adminRealtimeSocket;
};
